import { render, staticRenderFns } from "./ControllerPeopleInCharge.vue?vue&type=template&id=0497df5c&scoped=true&"
import script from "./ControllerPeopleInCharge.vue?vue&type=script&lang=js&"
export * from "./ControllerPeopleInCharge.vue?vue&type=script&lang=js&"
import style0 from "./ControllerPeopleInCharge.vue?vue&type=style&index=0&id=0497df5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0497df5c",
  null
  
)

export default component.exports